module.exports = __webpack_public_path__ + "static/media/cardboard-box.e16d303d.png";